/**************************************************
 * Nombre:       Nosotros_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from "../../../Recursos/fondo_nosotros.png";
import trofeo from "../../../Recursos/ic_trofeo.svg";
import confianza from "../../../Recursos/ic_confianza.svg";
import compania from "../../../Recursos/ic_compania.svg";
import tranui from "../../../Recursos/ic_tranquilidad.svg";
import {irAtras} from "../../../Utilidades/irAtras";
import {ArrowBackIos} from "@mui/icons-material";

const Nosotros_Portada = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(90deg, rgba(0, 0, 0, 0.70) -0.45%, rgba(0, 0, 0, 0.00) 66.18%), url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 8, md: 6}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: -6, ml: -16}}>
                            <Button
                                onClick={() => irAtras()}
                                variant={'text'} startIcon={<ArrowBackIos/>}>Atras</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 20}}>
                            <Typography sx={{fontSize: 48, fontWeight: 800}}>Nosotros</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                OVER RECEPTOUR se compromete a ofrecer a
                                sus clientes productos y servicios turísticos de alta calidad, oportunamente. A través
                                de proveedores confiables y responsables; adecuada tecnología, un personal competente y
                                comprometido con la mejora continúa de nuestros procesos, para lograr la satisfacción
                                del cliente.</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 4, mb: 14}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                A través de su desarrollo constante y sostenible, Over Receptour se ha colocado como una
                                empresa turística consolidada profesional y financieramente, gozando de un “good will”
                                en todos los ámbitos. Somos miembros de la Asociación Colombiana de Viajes y Turismo
                                ANATO.</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Nosotros_Portada

const caracteristicas = [
    {
        nombre: 'Calidad',
        imagen: trofeo,
        w: 38,
        mt: 1
    },
    {
        nombre: 'Confianza',
        imagen: confianza,
        w: 42,
        mt: 2
    },
    {
        nombre: 'Compañia',
        imagen: compania,
        w: 46,
        mt: 1.5
    },
    {
        nombre: 'Tranquilidad',
        imagen: tranui,
        w: 42,
        mt: 1.5
    },
]